import { useAppSelector } from '.';
import { RootState } from '../store';

const strapiDataSelector = (state: RootState) => state.strapi.strapiData;

export const useStrapiDataHelper = () => {
  const data: any = useAppSelector(strapiDataSelector);
  return data;
};
